import * as ng from 'angular';
import { ComponentRegistration } from '../../core';
import { Moment } from 'moment';
import { IActivitiesService } from './services/activities-service';
import { ISiteConfigService } from '../../core';
import { IToastMessageService, ISessionService } from '../../services';
import { Dto } from '../../data';
let template = require('./overview.html');
import { Templates } from "../../assets";

class OverviewComponent extends ComponentRegistration {

    constructor() {
        super('overview', {
            controller: OverviewController,
            templateUrl: template,
            controllerAs: 'overview',
            bindings: {
            }
        });
    }
}

interface IOverviewController {
}

class OverviewController implements IOverviewController {
    private static $inject: Array<string> = ['Activities', 'SiteConfig', 'toastMessageFactory', 'moment', 'Session'];
    public accountNotActivatedTemplateUrl: string = Templates.accountNotActivated;
    private session: any = {};
    private activities: Array<Dto.IAccountActivity> = [];
    private allActivities: Array<any> = [];
    private fpActivities: Array<Dto.IFrequentParkerActivity> = [];
    private phoneNumber:string = null;
    private reservedParkingEnabled: boolean = true;
    private frequentParkerActivityType: any;
    private criteria: Dto.IAccountActivityCriteria;
    private frequentParkerCriteria: Dto.IFrequentParkerActivityCriteria;
    private pointBalance: number;

    constructor(private Activities: IActivitiesService,
        private SiteConfig: ISiteConfigService,
        private toastMessageFactory: IToastMessageService,
        private moment: Moment,
        private Session: ISessionService) {

        console.log('OverviewController loading');
    }

    public $onInit(): void {
        if (!this.Session.assureActiveUserSession()) return;
        this.SiteConfig.getConfigAsync()
            .then((config) => {
                this.phoneNumber = config.customerSettings.contact.phoneNumber;
                this.reservedParkingEnabled = config.customerSettings.reservedParking.enabled;
            });

        this.frequentParkerActivityType = [
            { key: 0, value: null },
            { key: 1, value: 'Point Accrual' },
            { key: 2, value: 'Point Redemption' },
            { key: 3, value: 'Manual Point Adjustment' }
        ];

        this.criteria = {
            accountId: null,
            startDate: (this.moment as any)().startOf('month').toDate(),
            endDate: (this.moment as any)().endOf('month').toDate(),
            minAmount: null,
            maxAmount: null,
            mediaIdentifier: null,
            transactionType: null,
            pageSize: 0,
            pageNumber: 0
        } as Dto.IAccountActivityCriteria;

        this.frequentParkerCriteria = {
            frequentParkerAccountId: null,
            startDate: this.criteria.startDate,
            endDate: this.criteria.endDate,
            activityType: null,
            pageSize: 0,
            pageNumber: 0
        } as Dto.IFrequentParkerActivityCriteria;

        this.Activities.loadAccountWithActivities(this, this.criteria, this.frequentParkerCriteria).then(() => {
            if (this.session.account.status === 4) {
                this.toastMessageFactory.showWarningMessage('Your account is inactive. Please call ' + this.phoneNumber + ' to get your account reactivated.');
            }

            if (this.fpActivities.length <= 0) {
                this.Activities.getCurrentFppBalance(this.frequentParkerCriteria.frequentParkerAccountId)
                    .then((balance: number) => {
                        this.pointBalance = balance;
                    });
            } else {
                this.pointBalance = (this as any).fpSummary.endingBalance;
            }

        });

        console.log('OverviewController loaded');
    }
}

let ovrvwComponent = new OverviewComponent();
export default ovrvwComponent;
export { ovrvwComponent as OverviewComponent, IOverviewController, OverviewController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/overview.ts